import ModelButton from 'Features/Core/Components/ModelButton/ModelButton';
import useThemeStore from 'Theme/store';
import ContentMessageLoader from './ContentMessageLoader';
import useChatStore from 'Components/Chat/store';
import { cn } from 'utils/styles';

const GridCard = ({ message, loading, modelsIds, isGridView = false }) => {
  const isModelProviderError = useChatStore(
    (state) => state.isModelProviderError
  );

  const { theme } = useThemeStore();
  return (
    <div
      className={cn(
        `w-full col-span-1 p-4 flex gap-2 flex-col max-h-[calc(100dvh-450px)] rounded-[22px] shadow-settings-card`,
        {
          'bg-white': theme === 'light' && !isModelProviderError(message),
          'bg-night-black': theme === 'dark' && !isModelProviderError(message),
          'bg-seasalt bg-gradient-to-b from-brick-yellow/30 to-brick-yellow/0':
            theme === 'light' && isModelProviderError(message),
          'bg-jet bg-gradient-to-b from-brick-yellow/30 to-brick-yellow/0':
            theme === 'dark' && isModelProviderError(message),
          'border-[3px] border-seasalt':
            theme === 'light' && isModelProviderError(message),
          'border-[3px] border-night-black':
            theme === 'dark' && isModelProviderError(message),
        }
      )}
    >
      <ModelButton
        model={message?.model}
        message={message}
        isFinished={message?.finished}
        isSelected={message?.selected}
        isGridView={isGridView}
      />
      <div className="overflow-y-auto overflow-x-hidden overflow-rtl overflow-rtl-light h-full">
        <ContentMessageLoader
          message={message}
          loading={loading}
          modelsIds={modelsIds}
        />
      </div>
    </div>
  );
};

export default GridCard;
